var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 16a.5.5 0 0 1 .5.5v1A1.5 1.5 0 0 0 6.5 19h11a1.5 1.5 0 0 0 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-1a.5.5 0 0 1 .5-.5M11.5 6.082 8.825 8.374a.5.5 0 0 1-.65-.759l2.843-2.437a1.5 1.5 0 0 1 1.952 0l2.844 2.437a.5.5 0 1 1-.651.76L12.5 6.091V15a.5.5 0 1 1-1 0z",
    clipRule: "evenodd"
  })));
};
export default SvgUploadIcon;